export { default } from './CenteredSpinner';
